import { render, staticRenderFns } from "./Harmful.vue?vue&type=template&id=4ba11394&scoped=true"
import script from "./Harmful.vue?vue&type=script&lang=js"
export * from "./Harmful.vue?vue&type=script&lang=js"
import style0 from "./Harmful.vue?vue&type=style&index=0&id=4ba11394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba11394",
  null
  
)

export default component.exports